import { Component, OnInit,OnDestroy } from '@angular/core';
import { UserService } from '../../../modules/auth/services/user.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { User } from '../../../modules/auth/models/user.model';
import { Reclamation } from '../../../modules/reclamation/models/reclamation';
import Swal from 'sweetalert2';
import { TokenStorageService } from '../../../modules/auth/services/token-storage.service';
import { DocService } from '../../../shared/services/document.service';
import { Doc } from '../../models/document.model';
@Component({
  selector: 'app-document-admin',
  templateUrl: './document-admin.component.html',
  styleUrls: ['./document-admin.component.scss']
})
export class DocumentAdminComponent implements OnInit {
  public reclamation: Reclamation;
  public imagePreview: string;
  fileUploaded = false; 
  public loading = false;
  errormsg:string;
  submitted=false
  user: User;
  informations=[]
  usertype: string;
  users: User[]=[];
  filtredusers: any[]=[];
  prenom: any;
  nom: any;
  raisonsociale: any;
  nature: any;
  usersSub: any;
  public showphase=false
  public showall=false
  effectiveuser: User;
  currentuser: any;
  alldocSub: any;
  documentslist: Doc[]=[];
  type:any
  role: string;
  documentfile: File;
  selectedUserTypes= []; // Changed to array to handle multiple selections
  userTypes = [
    { value: 'Clientpor', label: 'Client porteur', selected: false },
    { value: 'Clientcomm', label: 'Client commerçant', selected: false },
    { value: 'Metier', label: 'Métier', selected: false },
    { value: 'Agence', label: 'Agence', selected: false },
    { value: 'comite arbitrage', label: 'Comité Arbitrage', selected: false }
  ];
  comm: string;
  title: string;
  constructor( private route: ActivatedRoute, private router: Router,private docserv: DocService,private docadmin: DocService,    private tokenStorage: TokenStorageService,
    private userservice: UserService,
    ) {}
    reloadPage(): void { 
      setTimeout(() => window.location.reload());
    }
    afficher4()
{
  this.loading = true;
      // Collect selected user types
      this.selectedUserTypes = this.userTypes
      .filter(type => type.selected)
      .map(type => type.value);
const newdoc= new Doc() 
newdoc.profils=[]
newdoc.commentaire=this.comm
newdoc.titre=this.title
newdoc.ficheurl=''
newdoc.profils = this.selectedUserTypes; // Include the selected user types
  this.docadmin.create(newdoc,this.documentfile||'').then(
    (data:any) => {
      this.loading = false;
Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'document ajouté avec succès!',
        showConfirmButton: false,
        timer: 6000 
      });
          this.reloadPage();
    },
    (error) => {
      this.loading = false;
      
    }
  );
}
    filteracteur(value:any):any
{
  let view=[]
  value.forEach(element => {
    element=='Clientpor'?view.push('Client Porteur'):
    element=='Clientcomm'?view.push('Client Commerçant'):
    element=='Metier'?view.push('Métier'):
    element=='Agence'?view.push('Agence'):
    element=='comite arbitrage'?view.push('Comité arbitrage'):''
  });
  return view
}
  ngOnInit() {
    if (this.tokenStorage.getToken()){
      this.currentuser =this.tokenStorage.getUser()
      this.userservice.getUserById(this.currentuser.userId).then(
        (user: User) => {
          this.loading = false;
          console.log(user)
          this.type = user.usertype??user.role;
          this.role=user.role
          this.docserv.getDocs(this.type)
        }
      )
    }
  this.loading = true;
  this.alldocSub = this.docserv.docs$.subscribe(
    (docs) => {
      this.loading=false
      this.documentslist = docs;
    },
    (error) => {
      this.loading = false;
      this.errormsg=error.message;
    }
  );
  }
  getNavigation(link,id){
    this.router.navigate([link + '/' + id]); 
  }
  deleteDocument(docId: string): void {
    Swal.fire({
      title: 'Êtes-vous sûr?',
      text: 'Voulez-vous vraiment supprimer ce document?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui, supprimer!',
      cancelButtonText: 'Non, conserver'
    }).then((result) => {
      if (result.isConfirmed) {
        this.docserv.deleteDocdataById(docId).then(
          () => {
            this.documentslist = this.documentslist.filter(doc => doc._id !== docId);
            Swal.fire('Supprimé!', 'Le document a été supprimé.', 'success');
          },
          error => {
            console.error('Erreur lors de la suppression du document:', error);
            Swal.fire('Erreur!', 'Un problème est survenu lors de la suppression du document.', 'error');
          }
        );
      }
    });
  }
  myFunction4() {
    var checkbox:any = document.getElementById("myCheck4");
    var text2 = document.getElementById("bodycontainer4");
    if (checkbox.checked == true){
      text2.style.display = "block";
    } else {
      Swal.fire({
        title: 'Vous êtes sur le point de réinitialiser tous les donnés relatifs au formulaire d\'ajout des documents, voulez vous continuer?',
        
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Réinitialiser',
        cancelButtonText: 'Annuler',
      }).then((result) => {
        if (result.value) {  
          text2.style.display = "none";
        }
        else{
          checkbox.checked = true
          text2.style.display = "block";
        }
      }).catch(() => {
        Swal.fire('opération non aboutie!');
      });
    }
  }
  onImagePick(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.documentfile = file;
  
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result as string;
      };
      reader.readAsDataURL(file);
    } else {
      // Handle case when no file is selected
      this.documentfile = null;
      this.imagePreview = null;
    }
  }
}
